export default {
  "config": {
    "trial": "itc",
    "id": "teae-risk-diff",
    "type": "table",
    "title": "TEAE Risk Difference <no-break>(95% CrI)</no-break> of Solriamfetol <no-break>150 mg</no-break> vs Comparators<sup>6</sup><sup>,a</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
      "<sup>a</sup>Bold formatting indicates that the <no-break>95% CrI</no-break> does not cross the line of no effect.",
      "<sup>b</sup>Endpoint not reported by trial (i.e. individual TEAEs were reported but were not consolidated as <no-break>\"any TEAE\").</no-break>",
      "<sup>c</sup>Individual TEAE was not reported in the trial. The assumed incidence was <no-break><5%,</no-break> so risk difference could not be calculated."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "itc",
    "id": "teae-risk-diff",
    "data-type": "table",
    "title": "TEAE Risk Difference <no-break>(95% CrI)</no-break> of Solriamfetol <no-break>150 mg</no-break> vs Comparators<sup>6</sup><sup>,a</sup>",
    "num-header-rows": 1,
    "num-columns": 8,
    "col-classes": [
      "col-1",
      "pbo",
      "sol",
      "sol",
      "sol",
      "sol",
      "sol"
    ],
    "row-mergeoption": [
      1
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-a",
      "footnote-b",
      "footnote-c"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
    "footnote-a": "<sup>a</sup>Bold formatting indicates that the <no-break>95% CrI</no-break> does not cross the line of no effect.",
    "footnote-b": "<sup>b</sup>Endpoint not reported by trial (i.e. individual TEAEs were reported but were not consolidated as <no-break>\"any TEAE\").</no-break>",
    "footnote-c": "<sup>c</sup>Individual TEAE was not reported in the trial. The assumed incidence was <no-break><5%,</no-break> so risk difference could not be calculated.",
    "data": {
      "row-0": [
        {
          "indent": 0,
          "content": "<b>Outcome</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Armodafinil <no-break>150 mg qd</no-break></b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>Armodafinil <no-break>250 mg qd</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Modafinil <no-break>200 mg qd</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Modafinil <no-break>400 mg qd</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>75 mg qd</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>300 mg qd</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "Any TEAE",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "NR<sup>b</sup>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "NR<sup>b</sup>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.070 <no-break>(–0.162,</no-break> 0.305)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "NR<sup>b</sup>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.235 (0.081, 0.379)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.073</no-break> <no-break>(–0.202,</no-break> 0.058)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.241 (0.111, 0.363)",
          "cols": 1
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Serious TEAE",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.009</no-break> <no-break>(–0.061</no-break>, 0.012)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.001</no-break> <no-break>(–0.039,</no-break> 0.017)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.016</no-break> <no-break>(–0.246,</no-break> 0.010)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.015</no-break> <no-break>(–0.191,</no-break> 0.010)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0 <no-break>(–0.017,</no-break> 0.016)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.001 <no-break>(–0.007,</no-break> 0.017)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.002</no-break> <no-break>(–0.009,</no-break> 0.015)",
          "cols": 1
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "TEAE leading to discontinuation",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.003</no-break> <no-break>(–0.056,</no-break> 0.093)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.033</no-break> <no-break>(–0.124,</no-break> 0.070)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.085</no-break> <no-break>(–0.280,</no-break> 0.045)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.109</no-break> <no-break>(–0.293,</no-break> 0.025)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.011 <no-break>(–0.059,</no-break> 0.083)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.078</no-break> <no-break>(–0.215,</no-break> <no-break>–0.013)</no-break>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.008 <no-break>(–0.024,</no-break> 0.100)",
          "cols": 1
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Anxiety",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0.127 <no-break>(–0.077,</no-break> 0.956)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0.117 <no-break>(–0.114,</no-break> 0.953)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.138 <no-break>(–0.050,</no-break> 0.959)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.128 <no-break>(–0.072,</no-break> 0.956)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.040 <no-break>(–0.139,</no-break> 0.377)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.143</no-break> <no-break>(–0.408,</no-break> <no-break>–0.005)</no-break>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.159 (0.009, 0.966)",
          "cols": 1
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "Diarrhea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0.084 <no-break>(–0.051,</no-break> 0.631)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0.091 <no-break>(–0.051</no-break>, 0.634)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.105 <no-break>(–0.011,</no-break> 0.640)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>0.113 (0.003, 0.644)</b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.007</no-break> <no-break>(–0.245,</no-break> 0.209)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.057</no-break> <no-break>(–0.29,</no-break> 0.093)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.106 <no-break>(–0.001</no-break>, </no-break>0.641)</no-break>",
          "cols": 1
        }
      ],
      "row-6": [
        {
          "indent": 0,
          "content": "Dry mouth",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.001</no-break> <no-break>(–0.278,</no-break> 0.077)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.165</no-break> <no-break>(–0.800,</no-break> 0.033)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "NR<sup>c</sup>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "NR<sup>c</sup>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.007 <no-break>(–0.010,</no-break> 0.065)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.009</no-break> <no-break>(–0.080,</no-break> 0.011)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.007 <no-break>(–0.004,</no-break> 0.074)",
          "cols": 1
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "Headache",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.073</no-break> <no-break>(–0.176,</no-break> 0.048)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.132</no-break> <no-break>(–0.274,</no-break> 0.008)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.073</no-break> <no-break>(–0.183,</no-break> 0.049)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.095</no-break> <no-break>(–0.205,</no-break> 0.028)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.007 <no-break>(–0.095,</no-break> 0.096)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.059</no-break> <no-break>(–0.163,</no-break> 0.022)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.002 <no-break>(–0.054,</no-break> 0.103)",
          "cols": 1
        }
      ],
      "row-8": [
        {
          "indent": 0,
          "content": "Insomnia",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.027</no-break> <no-break>(–0.187,</no-break> 0.066)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.032</no-break> <no-break>(–0.207,</no-break> 0.063)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.055</no-break> <no-break>(–0.210,</no-break> 0.053)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.025</no-break> <no-break>(–0.123,</no-break> 0.070)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.011 <no-break>(–0.017,</no-break> 0.083)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.046</no-break> <no-break>(–0.207,</no-break> <no-break>–0.005)</no-break>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.006 <no-break>(–0.011,</no-break> 0.089)",
          "cols": 1
        }
      ],
      "row-9": [
        {
          "indent": 0,
          "content": "Nausea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0.020 <no-break>(–0.031,</no-break> 0.103)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.044</no-break> <no-break>(–0.168,</no-break> 0.055)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.066</no-break> <no-break>(–0.246,</no-break> 0.048)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.058</no-break> <no-break>(–0.203,</no-break> 0.049)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.023 <no-break>(–0.028,</no-break> 0.089)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.010</no-break> <no-break>(–0.071,</no-break> 0.042)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.017 <no-break>(–0.017,</no-break> 0.094)",
          "cols": 1
        }
      ]
    }
  }
};